import gql from "graphql-tag";

export const RevokeCustomerToken = gql`
    mutation RevokeCustomerToken {
        revokeCustomerToken {
            result
        }
    }
`;
